(() => {
	if (window.ThemeEvents) return;

	class ThemeEventBus {
		constructor() {
			this.events = {};
			this.backlog = {};
		}

		subscribe(name, cb) {
			if (!this.events[name]) this.events[name] = [];
			this.events[name].push(cb);

			const q = this.backlog[name];
			if (q && q.length) {
				q.forEach((payload) => {
					try { cb(payload); } catch (e) { console.error(e); }
				});
				this.backlog[name] = [];
			}

			return () => this.unsubscribe(name, cb);
		}

		unsubscribe(name, cb) {
			const list = this.events[name];
			if (!list) return;
			this.events[name] = list.filter((fn) => fn !== cb);
		}

		emit(name, payload) {
			const list = this.events[name];
			if (!list || !list.length) {
				(this.backlog[name] ||= []).push(payload);
				return;
			}
			[...list].forEach((fn) => {
				try { fn(payload); } catch (e) { console.error(e); }
			});
		}

		on(name, cb) { return this.subscribe(name, cb); }
		off(name, cb) { return this.unsubscribe(name, cb); }
		publish(name, payload) { return this.emit(name, payload); }
	}

	window.ThemeEvents = new ThemeEventBus();
})();
